/**
 * Labstep
 *
 * @module components/Metadata/Action/Create/Modal/Message
 * @desc Message for metadata template field
 */

import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import { Message } from 'semantic-ui-react';
import type { MetadataActionCreateMessageProps } from './types';

export const MetadataActionCreateModalMessage: React.FC<
  MetadataActionCreateMessageProps
> = ({ entityName }) => {
  const entities = getHumanReadableEntityName(entityName, true);
  return (
    <Message color="yellow">
      {`You are adding a template field. This field will
  appear on all ${entities} using this template.`}
    </Message>
  );
};
